import { resolveEndpoint } from "@/config/endpoint-resolver";
import { ApolloClient, DefaultOptions } from "apollo-client";
import { createHttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";

// HTTP connection to the API
const httpLink = createHttpLink({
  // uri as a function is re-evaluated per operation, so a Flagsmith per-group
  // override is applied at request-time, not pinned at link creation.
  uri: () => resolveEndpoint("VITE_GQL_GW"),
});

// Cache implementation
const cache = new InMemoryCache();

// 1- For now, we do not need apollo client to store data in cache
// we need every graphql query to fetch from remote, not to read from apollo cache
// 2- In future (TODO), we need to set cases where we can cache and read from cache
// and cases where we should fetch from remote again
// e.g: Set cache as default (just remove the use of the below defaultOptions) and when we have
// and when we have a posConfig updated (PSC updated or timeSlot updated ...etc) we override the default options
// inside the function running the query (e.g: getTicketGroupsProductCategories()) so that the query triggers a fetch
// instead of just reading from apollo cache
const defaultOption: DefaultOptions = {
  watchQuery: {
    fetchPolicy: "no-cache",
    errorPolicy: "ignore",
  },
  query: {
    fetchPolicy: "no-cache",
    errorPolicy: "all",
  },
};

// Create the apollo client
export const badgeApolloClient = new ApolloClient({
  link: httpLink,
  cache,
  defaultOptions: defaultOption,
});
